import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FilterModal from 'LocalGluons/components/FilterModal';

const Filter = ({ navigation, route }) => {
    const { items, heading, onFilter } = route.params?.filterParams;
    const [filteredItems, setFilteredItems] = useState(items || []);

    const onClose = () => {
        navigation.pop();
        onFilter(filteredItems);
    };

    const onChange = (changedItem) => {
        const changedItems = filteredItems.map((item) => {
            if (item.id === changedItem.id) {
                return {
                    ...changedItem,
                    isSelected: !changedItem.isSelected
                };
            }
            return item;
        });
        setFilteredItems(changedItems);
    };

    return (
        <FilterModal
            heading={heading}
            items={filteredItems}
            onClose={onClose}
            onChange={onChange}
        />
    );
};

Filter.propTypes = {
    navigation: PropTypes.shape({}).isRequired
};

export default Filter;
